export default {
    termsAndConditions: {
        href: "https://monday.com/l/legal/ai/",
        target: "_blank"
    },
    termOfService: {
        href: "https://monday.com/trustcenter",
        target: "_blank"
    },
    privacyPolicy: {
        href: "https://monday.com/l/privacy/privacy-policy/",
        target: "_blank"
    }
};
